import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connectWithElement, removeConnectionWithElement } from 'modules/elements/actions';
import AffiliationCard from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.affiliation,
    app: state.app,
    user: state.session.user,
    userElements: state.elements.selectedElements,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    connectWithElement: bindActionCreators(connectWithElement, dispatch),
    removeConnectionWithElement: bindActionCreators(removeConnectionWithElement, dispatch),
  };
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AffiliationCard));



// WEBPACK FOOTER //
// ./src/components/AffiliationCard/container/index.js